import { RECEIVE_FACILITIES_META_DATA } from "../actions/facilitiesMetaActions";

const initialState = {
};

export default function facilitiesMetaReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_FACILITIES_META_DATA:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/facilitiesMetaReducer.js